<template>
  <v-layout
    align-center
    justify-center
  >
    <modalAlert ref="modalAlert" />
    <v-row
      justify="space-around"
    >
      <v-card
        width="100%"
        max-width="800px"
        elevation="24"
        :loading="bFlagLoading"
      >
        <v-toolbar
          color="light-blue"
          dark
          flat
        >
          <v-toolbar-title>Registro de eleitor</v-toolbar-title>
          <v-spacer />
          <v-tooltip right>
            <template />
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-form
            ref="formVoterRegistration"
          >
            <v-text-field
              label="Eleição"
              v-model="electionName"
              :rules="requiredRules"
              readonly
            />
            <v-text-field
              label="Nome"
              v-model="name"
              :rules="requiredRules"
            />
            <v-text-field
              label="E-mail"
              v-model="email"
              :rules="emailValidation()"
              readonly
            />
            <v-text-field
              label="CPF"
              v-model="cpf"
              v-on:keyup="formatCPF"
              :rules="[cpfValidate]"
            />
            <v-text-field
              label="RG"
              v-model="rg"
            />
            <v-text-field
              label="Título de eleitor"
              v-model="treNumber"
              v-on:keyup="formatElectorTitle"
              :rules="[validateElectorTitle]"
            />
            <v-text-field
              label="Zona do título"
              v-model="treZone"
              type="number"
              :rules="requiredRules"
            />
            <v-text-field
              label="Seção do título"
              v-model="treSection"
              type="number"
            />
            <v-text-field
              label="Data de nascimento"
              v-model="birth"
              type="date"
              :rules="requiredRules"
            />
            <v-text-field
              label="Nome da mãe"
              v-model="motherName"
              :rules="requiredRules"
            />
            <v-row>
              <v-col
                align="center"
                justify="center"
              >
                <vue-recaptcha
                  :sitekey="sitekey"
                  @verify="onVerify"
                  ref="recaptcha"
                />
                <span
                  v-if="showMessageRecaptcha"
                  class="v-messages theme--light error--text"
                >{{msgCaptcha}}</span>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="salvar"
            color="primary"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-layout>
</template>
<script>
import validate from '@/utils/validations';
import util from '@/utils/util';
import modalAlert from '@/components/ModalAlert';
import { mapActions } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    modalAlert,
    VueRecaptcha
  },
  data: () => ({
    electionName: '',
    name: '',
    email: '',
    cpf: '',
    rg: '',
    treNumber: '',
    treZone: '',
    treSection: '',
    birth: '',
    motherName: '',
    ipAddress: '',
    bFlagLoading: false,
    hashVoterRegistration: null,
    requiredRules: [v => !!v || 'Campo obrigatório'],
    messenger: {
      EMAIL: {
        email_e_obrigatorio: 'E-mail é obrigatório.',
        email_invalido: 'E-mail inválido.'
      },
      CPF: {
        cpf_e_obrigatorio: 'CPF é obrigatório.',
        cpf_invalido: 'CPF inválido.'
      },
      ELECTOR_TITLE: {
        titulo_e_obrigatorio: 'O número do título eleitoral é obrigatório.',
        titulo_invallido: 'O título é inválido.'
      }
    },
    sitekey: '6Lfz-fMZAAAAAP2Lt8N7p-SyiFLaGQKEuHcDU3Be',
    recaptcha: '',
    showMessageRecaptcha: false,
    msgCaptcha: 'Captcha é obrigatório'
  }),
  mounted() {
    this.verifyHash();
  },
  methods: {
    onVerify(response) {
      this.recaptcha = response;
      this.showMessageRecaptcha = false;
    },
    ...mapActions('voterRegistration', { emailConfirmation: 'emailValidate', completeRegistration: 'completeRegistration' }),
    async verifyHash() {
      this.bFlagLoading = true;
      this.hashVoterRegistration = this.$store.state.voterRegistrationHash;
      await this.getIpClient();
      if (this.hashVoterRegistration) {
        const data = {
          hash: this.hashVoterRegistration
        };
        if (this.ipAddress) {
          data.ipAddress = this.ipAddress;
        }
        try {
          await this.emailConfirmation(data);
          if (this.$store.state.voterRegistration.status === 'ok') {
            this.fillDataLocal();
          } else {
            const txtTitle = 'Alerta';
            const txtMessage = this.$store.state.voterRegistration.messageError;
            const funcCallBack = this.redirectElection;
            this.$refs.modalAlert.Load(true, txtTitle, txtMessage, funcCallBack, 'error');
          }
        } catch (error) {
          alert(error);
        } finally {
          this.bFlagLoading = false;
        }
      } else {
        this.$refs.modalAlert.Load(
          true,
          'Chave de acesso.',
          'Chave de acesso inexistente.',
          function() {
            this.$router.push({ name: 'Election' });
          },
          'error'
        );
      }
    },
    fillDataLocal() {
      const data = this.$store.state.voterRegistration;
      if (data) {
        this.id = data.id;
        this.electionName = data.electionName;
        this.name = data.name;
        this.email = data.email;
        this.cpf = data.cpf;
        this.rg = data.rg;
        this.treNumber = data.treNumber;
        this.treZone = data.treZone;
        this.treSection = data.treSection;
        this.birth = data.birth;
        this.motherName = data.motherName;
      }
    },
    formatCPF() {
      const valueCPF = this.cpf;
      if (valueCPF) {
        this.cpf = util.formatCPF(valueCPF);
      }
    },
    cpfValidate() {
      let cpfIn = this.cpf;
      let messeger = '';
      if (cpfIn) {
        cpfIn = util.removeMask(cpfIn);
        const result = validate.cpfValidation(cpfIn);
        if (!result) {
          messeger = this.messenger.CPF.cpf_invalido;
        }
      } else {
        messeger = this.messenger.CPF.cpf_e_obrigatorio;
      }

      if (messeger) {
        return messeger;
      } else {
        return true;
      }
    },
    formatElectorTitle() {
      const valueTitle = this.treNumber;
      if (valueTitle) {
        this.treNumber = util.formatElectoralTitle(valueTitle);
      }
    },
    validateElectorTitle() {
      let titleIn = this.treNumber;
      let message = '';
      if (titleIn) {
        titleIn = util.removeMask(titleIn);
        const result = validate.electorTitleValidator(titleIn);
        if (!result) {
          message = this.messenger.ELECTOR_TITLE.titulo_invallido;
        }
      } else {
        message = this.messenger.ELECTOR_TITLE.titulo_e_obrigatorio;
      }
      if (message) {
        return message;
      } else {
        return true;
      }
    },
    emailValidation() {
      const emailIn = this.email;
      let messeger = '';
      if (emailIn) {
        const result = validate.emailValidation(emailIn);
        if (!result) {
          messeger = this.messenger.EMAIL.email_invalido;
        }
      } else {
        messeger = this.messenger.EMAIL.email_e_obrigatorio;
      }

      if (messeger) {
        return [messeger];
      } else {
        return [true];
      }
    },
    async salvar() {
      if (this.recaptcha === '') {
        this.showMessageRecaptcha = true;
        return false;
      }

      if (this.$refs.formVoterRegistration.validate()) {
        const data = {
          hash: this.hashVoterRegistration,
          name: this.name,
          cpf: util.removeMask(this.cpf),
          rg: this.rg,
          treNumber: util.removeMask(this.treNumber),
          treSection: this.treSection,
          treZone: this.treZone,
          birth: this.birth,
          motherName: this.motherName,
          recaptcha: this.recaptcha
        };
        await this.getIpClient();
        if (this.ipAddress) {
          data.ipAddress = this.ipAddress;
        }
        try {
          await this.completeRegistration(data);
          if (this.$store.state.voterRegistration.status === 'ok') {
            this.concluirRegistro();
          } else {
            let msg = '';
            if (this.$store.state.voterRegistration.messageError) {
              msg = this.$store.state.voterRegistration.messageError;
            } else {
              msg = 'Tente novamente mais tarde.';
            }
            this.$refs.modalAlert.Load(
              true,
              'Problemas ao concluir o cadastro.',
              msg,
              null,
              'error',
              this.resetRecaptcha()
            );
          }
        } catch (error) {
          this.resetRecaptcha();
          alert(error);
        }
      }
    },
    async getIpClient() {
      this.ipAddress = null;
      await fetch('https://api.ipify.org?format=json').then(response => response.json()).then(response => {
        this.ipAddress = response.ip;
      });
    },
    concluirRegistro() {
      const txtTitle = 'Registro completado com sucesso!';
      const txtMessage = 'Aguarde a validação dos seus dados.';
      const funcCallBack = this.redirectElection;
      this.$refs.modalAlert.Load(true, txtTitle, txtMessage, funcCallBack, 'success');
    },
    redirectElection() {
      this.$router.push({ name: 'Election' });
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.recaptcha = '';
    }
  }
};
</script>
